import type { AppContentLocale } from "@yahshi/contracts";
import "./i18n.css";

export function PublicLocaleSwitch({
  locale,
  onChange,
}: {
  locale: AppContentLocale;
  onChange: (locale: AppContentLocale) => void;
}) {
  return (
    <div className="public-locale-switch" role="group" aria-label="语言">
      <button type="button" lang="zh" aria-pressed={locale === "zh"} onClick={() => onChange("zh")}>中文</button>
      <button type="button" lang="ug" aria-pressed={locale === "ug"} onClick={() => onChange("ug")}>ئۇيغۇرچە</button>
    </div>
  );
}
